/*
 *
 * AudienceDetail constants
 *
 */

export const FLUSH_STATE_AUDIENSE = 'app/AudienceDetail/FLUSH_STATE_AUDIENSE';

export const INITIAL_ID = 'app/AudienceDetail/INITIAL_ID';

// LOAD Single
export const LOAD_AUDIENSE = 'app/AudienceDetail/LOAD_AUDIENSE';
export const LOAD_AUDIENSE_SUCCESS = 'app/AudienceDetail/LOAD_AUDIENSE_SUCCESS';
export const LOAD_AUDIENSE_ERROR = 'app/AudienceDetail/LOAD_AUDIENSE_ERROR';

// CHANGE/UPDATE Single
export const UPDATE_AUDIENSE = 'app/AudienceDetail/CHANGE_AUDIENSE';
export const UPDATE_AUDIENSE_SUCCESS =
  'app/AudienceDetail/CHANGE_AUDIENSE_SUCCESS';
export const UPDATE_AUDIENSE_ERROR =
  'app/AudienceDetail/CHANGE_AUDIENSE_ERROR';

  // DELETE Single
export const HARD_DELETE_AUDIENSE = 'app/AudienceDetail/HARD_DELETE_AUDIENSE';
export const HARD_DELETE_AUDIENSE_SUCCESS = 'app/AudienceDetail/HARD_DELETE_AUDIENSE_SUCCESS';
export const HARD_DELETE_AUDIENSE_ERROR = 'app/AudienceDetail/HARD_DELETE_AUDIENSE_ERROR';